export enum NotesEmailsFormLabelsEnum {
  NOTES = 'Notes',
  EMAILS = 'Emails',
}
